import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'

// 创建axios实例
const service = axios.create({
  baseURL: '/api',
  timeout: 600000  // 600秒超时（10分钟）
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    // 只显示业务错误信息
    if (error.response && error.response.data && error.response.data.msg) {
      Message({
        message: error.response.data.msg,
        type: 'error',
        duration: 5 * 1000
      })
    }
    
    // 处理特定错误码
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 未登录或 token 过期
          localStorage.removeItem('token')
          router.push('/login')
          break
        case 403:
          // 无权限
          break
        case 404:
          // 接口不存在
          console.error('API not found:', error.config.url)
          break
      }
    }
    
    return Promise.reject(error)
  }
)

export default service 